<!-- BarChartVertical.vue -->
<script setup lang="ts">
import { computed, onMounted, PropType, ref } from "vue";

const props = defineProps({
  categories: { type: Array as PropType<string[]>, required: true },
  values: { type: Array as PropType<number[]>, required: true },
});

const primaryColor = ref("#4F7DF3"); // sensible fallback

onMounted(() => {
  const resolved = getComputedStyle(document.documentElement)
    .getPropertyValue("--color-primary")
    .trim();
  if (resolved) primaryColor.value = resolved;
});

const option = computed(() => ({
  tooltip: {},
  grid: {
    left: 0,
    right: 0,
    top: 30,
    bottom: 0,
    containLabel: true,
  },
  xAxis: {
    type: "category",
    data: props.categories,
    axisTick: { show: false },
    axisLine: { show: false },
  },
  yAxis: {
    show: false,
  },
  series: [
    {
      color: primaryColor.value,
      type: "bar",
      data: props.values,
      barWidth: "40%",
      itemStyle: { borderRadius: [10, 10, 0, 0] },
      label: {
        show: true,
        position: "top",
        fontWeight: "bold",
      },
    },
  ],
}));
</script>

<template>
  <VChart :option="option" autoresize />
</template>
